// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import FlightForm from './FlightForm';
import LodgingForm from './LodgingForm';
import TransportForm from './TransportForm';

export default class TravelForm extends React.PureComponent {
  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { event } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (event.eventCategory === 'Flight') {
      return <FlightForm {...this.props} />;
    }
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (event.eventCategory === 'Lodging') {
      return <LodgingForm {...this.props} />;
    }
    return <TransportForm {...this.props} />;
  }
}
